module.exports = __webpack_public_path__ + "static/media/ic_license_active.ad3e3479.svg";